
import './App.css';

import {Header} from './Header';
import {Home} from './Home';
import {About} from './About';
import {Productdetails} from './Productdetails';
import {Cart} from './Cart';
import {BrowserRouter,Route,Routes} from 'react-router-dom';
import { useEffect, useState } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css'


function App() {
  useEffect(()=>{
    Aos.init();
  }, [])
  const [array,setArray] = useState([])
  console.log(array) 
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Header array={array}/>}>
             <Route index element={<Home/>}>

             </Route>
             <Route path='/about' element={<About/>}>


             </Route>
             <Route path='/product' element={<Productdetails setArray = {setArray} array = {array}/>}>

             </Route>
             <Route path='/cart' element={<Cart array={array} setArray = {setArray}></Cart>}>

             </Route>
             
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
